import { styled } from '@mui/material/styles'
import { IconButton, Typography, MenuItem } from '@mui/material'

export const IconButtonWrapper = styled(IconButton, {
  shouldForwardProp: (props) => props !== 'isOpen' && props !== 'isIconOnly',
})<{ isOpen: boolean; isIconOnly: boolean }>(
  ({ isOpen, isIconOnly, theme }) => ({
    borderRadius: '3px',
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: isIconOnly ? 0 : theme.spacing(2),
    paddingLeft: isIconOnly ? 0 : theme.spacing(2),
    border:
      isOpen && !isIconOnly
        ? `1px solid ${theme.palette.primary.main}`
        : '1px solid transparent',
    [theme.breakpoints.between('xs', 'sm')]: {
      width: 'auto',
    },
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.icon.hover,
      svg: { fill: theme.palette.icon.hover },
    },
  })
)

export const IconDropdownText = styled(MenuItem)(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  display: 'flex',
  '&:hover': {
    background: theme.palette.secondary.main,
  },
  '&:focus': {
    background: 'transparent',
  },
  justifyContent: 'space-between',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}))

export const DropdownText = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.between('xs', 'sm')]: {
    display: 'none',
    '&:hover': {
      backgroundColor: theme.palette.commonColors.black,
    },
  },
}))
